import { colord, extend } from "colord";
import mixPlugin from "colord/plugins/mix";

extend([mixPlugin]);

export const lighten = (color: string, amount = 0.15) => colord(color).lighten(amount).toRgbString();

export const darken = (color: string, amount = 0.15) => colord(color).darken(amount).toRgbString();

export const tint = (color: string, amount = 0.15) => colord(color).mix("#fff", amount).toRgbString();

export const shade = (color: string, amount = 0.15) => colord(color).mix("#000", amount).toRgbString();

export const rgba = (color: string, alpha: number) => colord(color).alpha(alpha).toRgbString();

export const hex = (color: string) => colord(color).toHex();
